import { Tag, Text } from "@zapier/design-system";
import styles from "./DraftBanner.module.css";
import { sideBarSelectedAtom } from "@zapier/canvas-state";
import { useAtomValue } from "jotai";
import classNames from "classnames";
interface DraftBannerProps {
  message?: string;
}

export const DraftBanner: React.FC<DraftBannerProps> = ({
  message = "You're previewing a draft. Creating it will generate the assets in your Zapier account.",
}) => {
  const isSidebarOpen = useAtomValue(sideBarSelectedAtom);
  return (
    <div
      className={classNames(styles.wrapper, {
        [styles.sidebarOpen]: isSidebarOpen,
      })}
    >
      <Tag size="small" variant="warning">
        Draft
      </Tag>
      <div>
        <Text color="TextWeaker" type="Body1Multiline">
          {message}
        </Text>
      </div>
    </div>
  );
};

export default DraftBanner;
